module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "position": "relative"
    }
  }, [(_vm.loading) ? _c('div', {
    staticClass: "content content-centered"
  }, [_c('pulse-loader')], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12 text-right common_save_btn"
  }, [(_vm.$route.params && _vm.$route.params._id == '0') ? _c('a', [_c('router-link', {
    attrs: {
      "to": {
        name: 'Primarytrip'
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Cancel ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') ? _c('a', [_c('router-link', {
    attrs: {
      "to": {
        name: 'viewPrimaryTrip',
        params: {
          _id: _vm.$route.params._id
        },
      }
    }
  }, [_c('button', {
    staticClass: "mr-5 btn btn-default",
    attrs: {
      "type": "button"
    }
  }, [_vm._v(" Cancel ")])])], 1) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id == '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !(_vm.formstate.$dirty && _vm.formstate.$valid && _vm.selectDate)
    },
    on: {
      "click": _vm.createTrip
    }
  }, [_vm._v(" Save ")]) : _vm._e(), _vm._v(" "), (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') ? _c('button', {
    staticClass: "mr-2 btn gradientbt",
    attrs: {
      "type": "submit",
      "disabled": !((_vm.formstate.$dirty || _vm.selectDate || _vm.showDivision) && _vm.formstate.$valid)
    },
    on: {
      "click": _vm.updateTrip
    }
  }, [_vm._v(" Update ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.loading),
      expression: "!loading"
    }],
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body details_scrollbar"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.flash) ? _c('div', {
    staticClass: "flash-message col-md-4 col-md-offset-4 text-center"
  }, [_c('div', {
    staticClass: "alert",
    class: 'alert-' + _vm.flashType
  }, [_vm._v("\n              " + _vm._s(_vm.flashMessage) + "\n            ")])]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "details"
  }, [_c('vue-form', {
    attrs: {
      "state": _vm.formstate
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments)
      }
    }
  }, [_c('div', {
    staticClass: "collection_location_boxs"
  }, [_c('h4', [_vm._v("Collection Location")])]), _vm._v(" "), _c('div', {
    staticClass: "row collection_location_wrp"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.cityId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("City "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your City")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.cityId),
      expression: "primaryTrip.cityId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "cityId",
      "disabled": (_vm.$route.params && _vm.$route.params._id && _vm.$route.params._id != '0') || _vm.isCityDisable
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.primaryTrip, "cityId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getCityId($event.target.value)
      }, function($event) {
        return _vm.reset()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select City Name")]), _vm._v(" "), _vm._l((_vm.cities), function(cityId) {
    return _c('option', {
      domProps: {
        "value": cityId.id,
        "selected": cityId &&
          _vm.primaryTrip.cityId &&
          cityId.id === _vm.primaryTrip.cityId
      }
    }, [_vm._v(_vm._s(cityId.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "cityId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.area),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Zone "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your Zone")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.caId),
      expression: "primaryTrip.caId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "area",
      "required": ""
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.primaryTrip, "caId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }, function($event) {
        return _vm.getAreaById($event.target.value)
      }, function($event) {
        return _vm.reset()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Zone")]), _vm._v(" "), _vm._l((_vm.area), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item &&
          _vm.primaryTrip.caId &&
          item.id === _vm.primaryTrip.caId
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "area",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Area is a required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.divisionOrWard),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Division / Ward "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select Division/Ward")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('multiselect', {
    attrs: {
      "track-by": "cdName",
      "label": "cdName",
      "options": _vm.divisionWardList,
      "multiple": "",
      "name": "divisionOrWard",
      "required": ""
    },
    on: {
      "input": _vm.showWard
    },
    model: {
      value: (_vm.primaryTrip.cdId),
      callback: function($$v) {
        _vm.$set(_vm.primaryTrip, "cdId", $$v)
      },
      expression: "primaryTrip.cdId"
    }
  }), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "divisionOrWard",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("This is required field")])])], 1)])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "collection_location_boxs"
  }, [_c('h4', [_vm._v("Worker & Vehicle")])]), _vm._v(" "), _c('div', {
    staticClass: "row collection_location_wrp"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.driverId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Driver "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your Driver")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.driverId),
      expression: "primaryTrip.driverId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "driverId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.primaryTrip, "driverId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Driver")]), _vm._v(" "), _vm._l((_vm.driver_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item &&
          _vm.primaryTrip.driverId &&
          item.id === _vm.primaryTrip.driverId
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "driverId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Driver is a required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group",
    class: _vm.fieldClassName(_vm.formstate.helperId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Helper")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.helperId),
      expression: "primaryTrip.helperId"
    }],
    staticClass: "form-control",
    attrs: {
      "name": "helperId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.primaryTrip, "helperId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Helper")]), _vm._v(" "), _vm._l((_vm.helper_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item &&
          _vm.primaryTrip.helperId &&
          item.id === _vm.primaryTrip.helperId
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "helperId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Helper is a required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.vehicleId),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Vehicle "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select Vehicle")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.vehicleId),
      expression: "primaryTrip.vehicleId"
    }],
    staticClass: "form-control",
    attrs: {
      "required": "",
      "name": "vehicleId"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.primaryTrip, "vehicleId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": ""
    }
  }, [_vm._v("Select Vehicle")]), _vm._v(" "), _vm._l((_vm.vehicle_name), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id,
        "selected": item &&
          _vm.primaryTrip.vehicleId &&
          item.id === _vm.primaryTrip.vehicleId
      }
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                          ")])
  })], 2), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "vehicleId",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Vehicle is a required field")])])], 1)])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "collection_location_boxs"
  }, [_c('h4', [_vm._v("Collection Schedule")])]), _vm._v(" "), _c('div', {
    staticClass: "row collection_location_wrp collection_time_date_icon"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('validate', {
    staticClass: "form-group required-field",
    class: _vm.fieldClassName(_vm.formstate.scheduleTime),
    attrs: {
      "auto-label": ""
    }
  }, [_c('div', {
    staticClass: "form_dierction_msg"
  }, [_c('label', [_vm._v("Schedule Date and Time "), _c('span', {
    staticClass: "requred"
  }, [_vm._v("*")])]), _vm._v(" "), _c('span', [_vm._v("Select your Start Date & Time")])]), _vm._v(" "), _c('div', {
    staticClass: "input_field_validation"
  }, [_c('datetime', {
    staticClass: "theme-wm",
    attrs: {
      "required": "",
      "id": "scheduleTime",
      "type": "datetime",
      "min-datetime": new Date().toISOString(),
      "lang": "en",
      "name": "scheduleTime",
      "input-class": "form-control",
      "placeholder": "Start Date and Time"
    },
    on: {
      "input": function($event) {
        return _vm.selectItem($event)
      }
    },
    model: {
      value: (_vm.primaryTrip.scheduleTime),
      callback: function($$v) {
        _vm.$set(_vm.primaryTrip, "scheduleTime", $$v)
      },
      expression: "primaryTrip.scheduleTime"
    }
  }), _vm._v(" "), _c('svg', {
    attrs: {
      "id": "Layer_1",
      "data-name": "Layer 1",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 122.88 122.89"
    }
  }, [_c('title', [_vm._v("date")]), _vm._v(" "), _c('path', {
    attrs: {
      "d": "M81.61,4.73C81.61,2.12,84.19,0,87.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM66.11,105.66c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1ZM15.85,68.94c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14-10.1H107c.8,0,.8,10.1,0,10.1H91.25c-.8,0-.8-10.1,0-10.1ZM15.85,87.3c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1ZM41,87.3c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H81.9c.8,0,.8,10.1,0,10.1Zm25.14,0c-.8,0-.8-10.1,0-10.1H107c.8,0,.8,10.1,0,10.1Zm-75.4,18.36c-.8,0-.8-10.1,0-10.1H31.64c.8,0,.8,10.1,0,10.1Zm25.13,0c-.8,0-.8-10.1,0-10.1H56.77c.8,0,.8,10.1,0,10.1ZM29.61,4.73C29.61,2.12,32.19,0,35.38,0s5.77,2.12,5.77,4.73V25.45c0,2.61-2.58,4.73-5.77,4.73s-5.77-2.12-5.77-4.73V4.73ZM6.4,43.47H116.47v-22a3,3,0,0,0-.86-2.07,2.92,2.92,0,0,0-2.07-.86H103a3.2,3.2,0,0,1,0-6.4h10.55a9.36,9.36,0,0,1,9.33,9.33v92.09a9.36,9.36,0,0,1-9.33,9.33H9.33A9.36,9.36,0,0,1,0,113.55V21.47a9.36,9.36,0,0,1,9.33-9.33H20.6a3.2,3.2,0,1,1,0,6.4H9.33a3,3,0,0,0-2.07.86,2.92,2.92,0,0,0-.86,2.07v22Zm110.08,6.41H6.4v63.67a3,3,0,0,0,.86,2.07,2.92,2.92,0,0,0,2.07.86H113.55a3,3,0,0,0,2.07-.86,2.92,2.92,0,0,0,.86-2.07V49.88ZM50.43,18.54a3.2,3.2,0,0,1,0-6.4H71.92a3.2,3.2,0,1,1,0,6.4Z"
    }
  })]), _vm._v(" "), _c('field-messages', {
    staticClass: "form-control-feedback",
    attrs: {
      "name": "scheduleTime",
      "show": "$touched || $submitted"
    }
  }, [_c('div', {
    attrs: {
      "slot": "required"
    },
    slot: "required"
  }, [_vm._v("Start date is a required field")])])], 1)])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "colmn_inner colmn_inner_bdr"
  }, [_c('div', {
    staticClass: "boxs"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.trackBy),
      expression: "primaryTrip.trackBy"
    }],
    attrs: {
      "type": "radio",
      "name": "vehicle",
      "value": "vehicle",
      "id": "vehicle"
    },
    domProps: {
      "checked": _vm._q(_vm.primaryTrip.trackBy, "vehicle")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.primaryTrip, "trackBy", "vehicle")
      }, function($event) {
        return _vm.onSelectRadio('vehicle')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "vehicle"
    }
  }, [_vm._v("Track by Vehicle")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.primaryTrip.trackBy),
      expression: "primaryTrip.trackBy"
    }],
    attrs: {
      "type": "radio",
      "name": "driver",
      "value": "driver",
      "id": "driver"
    },
    domProps: {
      "checked": _vm._q(_vm.primaryTrip.trackBy, "driver")
    },
    on: {
      "change": [function($event) {
        return _vm.$set(_vm.primaryTrip, "trackBy", "driver")
      }, function($event) {
        return _vm.onSelectRadio('driver')
      }]
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "driver"
    }
  }, [_vm._v("Track by Driver")])])])])])])], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7539366"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/primaryTrip/addPrimaryTrip.vue
// module id = 2388
// module chunks = 1